import { useIntl } from 'react-intl';
import React from 'react';
import styles from './ReportEventSuccess.module.scss';

export const ReportEventSuccess = () => {
    const intl = useIntl();
    const successMessage = intl.formatMessage({
        id: 'We have flagged this event for investigation. If you provided contact information, we may follow up with you as needed.',
        defaultMessage: 'We have flagged this event for investigation. If you provided contact information, we may follow up with you as needed.',
    });
    return (
        <div data-testid="report-success-content">
            <p className={styles.successMessage}>{successMessage}</p>
        </div>
    );
};
